import React, { memo, useMemo, useState } from 'react';
import GroceryItemCard from './GroceryItemCard';
import './GroceryComponents.css';

const GroceryItemList = ({ items, onQuantityChange }) => {
  const [search, setSearch] = useState('');

  const visibleItems = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return items;
    return items.filter((item) => (item.itemName || '').toLowerCase().includes(term));
  }, [items, search]);

  const selectedCount = useMemo(
    () => items.filter((item) => Number(item.quantity) > 0).length,
    [items]
  );

  return (
    <div>
      <div className="grocery-toolbar">
        <input
          type="text"
          className="grocery-search"
          placeholder="Search items..."
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          aria-label="Search grocery items"
        />
        <span className="grocery-toolbar-count">
          {selectedCount > 0 ? `${selectedCount} selected` : `${items.length} items available`}
        </span>
      </div>

      {visibleItems.length === 0 ? (
        <div className="grocery-empty">No items match &ldquo;{search}&rdquo;.</div>
      ) : (
        <div className="grocery-item-grid">
          {visibleItems.map((item) => (
            <GroceryItemCard
              key={item.itemId}
              item={item}
              quantity={item.quantity}
              onQuantityChange={onQuantityChange}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(GroceryItemList);
